import React, { useEffect, useRef, useState } from 'react';

import './DesignCarousel.css';
// eslint-disable-next-line react/prop-types
const DesignCarouselMobile = ({ images }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState();
  const carouselItemsRef = useRef([]);
  const scrollToTop = useRef();
  const scrollRef = useRef();

  useEffect(() => {
    if (images && images[0]) {
      carouselItemsRef.current = carouselItemsRef.current.slice(
        0,
        // eslint-disable-next-line react/prop-types
        images.length,
      );

      setSelectedImageIndex(0);
      setSelectedImage(images[0]);
    }
  }, [images]);

  const handleSelectedImageChange = (newIdx) => {
    // eslint-disable-next-line react/prop-types
    if (images && images.length > 0) {
      setSelectedImage(images[newIdx]);
      setSelectedImageIndex(newIdx);
      scrollToTop?.current?.scrollTo(0, 0);
      if (scrollRef?.current) {
        scrollRef?.current?.scrollIntoView({
          inline: 'nearest',
          behavior: 'smooth',
        });
      }
    }
  };
  
  return (
    <div className="mobile-wrapper p-5 bg-gray">
      <div className="container-xl">
        <p ref={scrollRef}></p>
        <div className="pt-4 pb-5"></div>
        <div className="phone-wrapper">
          <img alt="mobile" src="./images/mobile.png"/>
          <div className="mobile-mockup-data">
            <div className="mobile-mockup-scroll">
              <div ref={scrollToTop} className="mockup-scroll-wrap">
                <div className="mockup-scroll-view">
                 <img alt="selected-image" className="selected-image-mobile" src={selectedImage?.url} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="carousel mobile pt-5">
          <div className="carousel-images pb-5">
            {images &&
              images.map((mobileImages, idx) => (
                <div
                  key={mobileImages.id}
                  className={`carousel-image-wrapper ${selectedImageIndex === idx ? 'carousel-image-selected' : ''}`}
                  onClick={() => handleSelectedImageChange(idx)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') handleSelectedImageChange(idx);
                  }}
                >
                  <div
                    className="carousel-image mobile"
                    style={{
                      backgroundImage: `url(${mobileImages.url})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center top',
                      backgroundSize: 'cover',
                    }}
                    ref={(el) => (carouselItemsRef.current[idx] = el)}
                  />
                  <div className="carousel-caption">{mobileImages.name}</div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignCarouselMobile;
